//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import zbParser from '@/components/FormGenerator/components/parser/ZBParser';
import { passAppSaveApi, configInfo, passAppInfoApi } from '@/api/systemConfig.js';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
export default {
  name: 'onePassConfig',
  components: {
    zbParser: zbParser
  },
  data: function data() {
    return {
      isShow: true,
      isCreate: 0,
      editData: {},
      formId: 144 //一号通配置
    };
  },
  mounted: function mounted() {
    if (checkPermi(['admin:pass:appget'])) this.getPassAppInfo();
  },
  methods: {
    checkPermi: checkPermi,
    resetForm: function resetForm(formValue) {
      this.isShow = false;
    },
    handlerSubmit: function handlerSubmit(data) {
      var _this = this;
      passAppSaveApi(data).then(function (res) {
        _this.getPassAppInfo();
        _this.$message.success('操作成功');
      });
    },
    //获取配置详情
    getPassAppInfo: function getPassAppInfo() {
      var _this2 = this;
      passAppInfoApi().then(function (res) {
        _this2.isShow = false;
        _this2.editData = res;
        _this2.isCreate = 1;
        setTimeout(function () {
          // 让表单重复渲染待编辑数据
          _this2.isShow = true;
        }, 80);
      });
    }
  }
};